import type { Receipt } from '@deposits/shared';
import { Money } from './Money';

/** A free receipt's amount. When a petty cash load took part of it, this is
 *  the remainder, with the full amount under it. */
export function ReceiptAmount({ receipt }: { receipt: Pick<Receipt, 'amount' | 'original_amount'> }) {
  return (
    <div>
      <Money amount={receipt.amount} />
      {receipt.original_amount != null && (
        <div className="text-small text-secondary-text">
          יתרה מתוך <Money amount={receipt.original_amount} />
        </div>
      )}
    </div>
  );
}
